import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route,  Outlet } from "react-router-dom";


import Login from "./components/Login";
import Signup from "./components/Signup";
import ProtectedRoute from "./components/ProtectedRoute";

import Sidebar from "./components/Sidebar";
import ProjectView from "./components/ProjectView";
import EditProjectForm from "./components/EditProjectForm";
import AllAPIView from "./components/AllAPIView";
import YamlViewer from "./components/YamlViewer";
import CreateProject from "./components/CreateProject";
import OrganizationView from "./components/OrganizationView";
import { useAuth } from "./Services/AuthContext";

import "./App.css";
import Logout from "./components/Logout";
import UserManagement from "./components/UserModule/UserManagement";
import ViewUser from "./components/UserModule/View/ViewUser";
import OrganizationAdminDash from "./components/OrganizationAdmin/OrganizationAdminDash";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";




const ProtectedLayout = ({
  isSidebarOpen,
  toggleSidebar,
  refreshProjects,
  setRefreshProjects,
}) => {
  return (
    
    <ProtectedRoute>
      <div className="app-container">
        
        {/* 🔥 MOVE TOAST HERE */}
        <ToastContainer position="top-right" autoClose={3000} />

        {/* LOGOUT (top-right) */}
        <Logout />

        {/* SIDEBAR */}
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          refreshProjects={refreshProjects}
        />

        {/* MAIN CONTENT */}
        <div className={`main-content ${isSidebarOpen ? "sidebar-open" : ""}`}>
          <button className="hamburger" onClick={toggleSidebar}>
            ☰
          </button>

          {/* 🔑 CHILD ROUTES RENDER HERE */}
          
          <Outlet />
        </div>
      </div>
    </ProtectedRoute>
  );
};



function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [refreshProjects, setRefreshProjects] = useState(false);
  const { user, loading: authLoading } = useAuth();

    const userName = user?.username || user?.userId || "User";

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Router>

      <Routes>


        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />


        

        {/* PROTECTED ROUTES */}
        <Route
        path="/"
          element={
            <ProtectedLayout
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
              refreshProjects={refreshProjects}
              setRefreshProjects={setRefreshProjects}
            />
          }
        >
          <Route
            index
            element={
              <div className="welcome-message">
                {/* <h1>Hii {userName}</h1> */}
                <h1> Welcome to API Manager</h1>
                <p>Select a project from the sidebar to get started.</p>
              </div>
            }
          />
          

          <Route
            path="organization/:organizationId/project/new"
            element={<CreateProject />}
          />

          <Route
            path="organization/:organizationId/project/:projectId"
            element={<ProjectView />}
          />

          <Route
            path="organization/:organizationId/project/:projectId/edit"
            element={<EditProjectForm />}
          />

          <Route
            path="organization/:organizationId/project/:projectId/yaml"
            element={<YamlViewer />}
          />

          <Route
            path="organization/:organizationId/view"
            element={<OrganizationView />}
          />

          <Route
            path="all-apis"
            element={<AllAPIView />}
          />

          <Route
            path="users/*"
            element={<UserManagement />}
          />
          <Route path="users/view/:userId" element={<ViewUser />} />

          <Route 
          path="organization-admin/*"
          element={<OrganizationAdminDash />}
          />
          
       
          
        </Route>
      </Routes>
    </Router>
    
  );
  
}


export default App;
